module.exports = __webpack_public_path__ + "img/arrow-right-to-bracket.81973e61.svg";